import inkStyles from './ink'

export default {
  base: () => ({}),
  ink: inkStyles,
}
